import { request, type RequestOptions } from './request'

type ClientRequestOptions<T> = Omit<RequestOptions<T>, 'url'> & { route: string }

export class ApiClient {
    constructor(
        private serverUrl: string,
        private token: string,
        private customerSlug: string
    ) {}

    public request<T, U>(requestOptions: ClientRequestOptions<T>, onProgress?: (bytesUploaded: number) => void) {
        return request<T, U>(
            {
                url: `${this.serverUrl}${requestOptions.route}`,
                body: requestOptions.body,
                method: requestOptions.method,
                headers: {
                    ...requestOptions.headers,
                    'Content-Type': 'application/json',
                    'x-zap-customer-slug': this.customerSlug,
                    Authorization: `Bearer ${this.token}`,
                },
            },
            onProgress
        )
    }
}
